export const popoverPlacements = [
  'left',
  'right',
  'top',
  'bottom',
  'topLeft',
  'leftTop',
  'topRight',
  'rightTop',
  'bottomRight',
  'rightBottom',
  'bottomLeft',
  'leftBottom',
] as const;

export type PopoverPlacement = typeof popoverPlacements[number];
